import a from "react";
import { c as r, t as g } from "./useKeyDown-88662051.mjs";
import { I as h, a as N } from "./Image-be3826ec.mjs";
import { L as b } from "./Link-460da2fc.mjs";
import { B as L } from "./Button-eec2778c.mjs";
import { C as S } from "./CallToAction-855b5705.mjs";
const T = "link-preview-card", B = "desktop", x = "image-container", E = "image", W = "badge", P = "link-wrapper", f = "preview-container", y = "preview-content", H = "card-title", A = "card-intro-text", M = "preview-link", O = "cta-hover", _ = "save-button-container", R = "cta", D = "no-images-card", F = "no-images-preview-content", V = "no-images-card-link-wrapper", j = "no-save-no-images-button-card-height", q = "no-save-button-card-link-wrapper", z = "no-save-no-images-link-wrapper", G = "no-save-button-preview-content", J = "no-save-button-cta", K = "hide-cta-on-mobile", e = {
  linkPreviewCard: T,
  desktop: B,
  imageContainer: x,
  image: E,
  badge: W,
  linkWrapper: P,
  previewContainer: f,
  previewContent: y,
  cardTitle: H,
  cardIntroText: A,
  previewLink: M,
  ctaHover: O,
  saveButtonContainer: _,
  cta: R,
  noImagesCard: D,
  noImagesPreviewContent: F,
  noImagesCardLinkWrapper: V,
  noSaveNoImagesButtonCardHeight: j,
  noSaveButtonCardLinkWrapper: q,
  noSaveNoImagesLinkWrapper: z,
  noSaveButtonPreviewContent: G,
  noSaveButtonCta: J,
  hideCtaOnMobile: K
};
function ae(l) {
  const {
    cardTitle: i,
    cardIntroText: d,
    link: m,
    linkLabel: s,
    linkLocale: v,
    imageProps: t,
    hasImages: n,
    hasSaveButton: o,
    showCTAOnMobile: p = !0,
    newTab: c = !0,
    onSave: k,
    isSaved: w,
    badge: C
  } = l, u = r(e.linkPreviewCard, {
    [e.noImagesCard]: !n,
    [e.noSaveNoImagesButtonCardHeight]: !o && !n,
    [e.hideCtaOnMobile]: !p
  }), I = r(e.linkWrapper, {
    [e.noImagesCardLinkWrapper]: !n,
    [e.noSaveButtonCardLinkWrapper]: !o,
    [e.noSaveNoImagesLinkWrapper]: !n && !o
  });
  return /* @__PURE__ */ a.createElement("div", { className: u, "data-testid": "link-preview-container" }, n && t && /* @__PURE__ */ a.createElement("div", { className: e.imageContainer }, /* @__PURE__ */ a.createElement(
    h,
    {
      credits: t.credits,
      src: t.src,
      width: t.width,
      height: t.height,
      altText: t.altText,
      imageLoader: t.imageLoader,
      className: e.image,
      styling: N.PREVIEW_CARD,
      "data-testid": "link-preview-image"
    }
  ), C && /* @__PURE__ */ a.createElement("div", { className: e.badge, "data-testid": "link-preview-badge" }, C)), /* @__PURE__ */ a.createElement("div", { className: I }, /* @__PURE__ */ a.createElement(
    b,
    {
      href: m,
      locale: v,
      "aria-label": i,
      disableLinkTextStyle: !0,
      className: e.previewLink,
      target: c ? "_blank" : void 0,
      "data-testid": "link-preview-link"
    },
    /* @__PURE__ */ a.createElement("div", { className: e.previewContainer, "aria-hidden": "true" }, /* @__PURE__ */ a.createElement(
      Q,
      {
        cardIntroText: d,
        cardTitle: i,
        linkLabel: s,
        hasImages: n,
        hasSaveButton: o,
        newTab: c
      }
    ))
  ), o && /* @__PURE__ */ a.createElement(
    L.Save,
    {
      onClick: k,
      iconFilled: w,
      containerClassName: e.saveButtonContainer,
      "data-testid": "link-preview-save"
    }
  )));
}
const Q = (l) => {
  const { cardIntroText: i, cardTitle: d, hasImages: m, hasSaveButton: s, linkLabel: v, newTab: t } = l, n = r(e.previewContent, {
    [e.noImagesPreviewContent]: !m,
    [e.noSaveButtonPreviewContent]: !s
  }), o = r(
    g.textsComponentTitleBold,
    e.cardTitle
  ), p = r(
    g.textsBodyText,
    e.cardIntroText
  ), c = r(
    e.cta,
    e.ctaHover,
    s ? "" : e.noSaveButtonCta
  );
  return /* @__PURE__ */ a.createElement("div", { className: n, "data-testid": "link-preview" }, /* @__PURE__ */ a.createElement("h3", { className: o }, d), /* @__PURE__ */ a.createElement("p", { className: p }, i), /* @__PURE__ */ a.createElement(
    S,
    {
      containerClassName: c,
      as: "div",
      text: v,
      showCTAIcon: t
    }
  ));
};
export {
  ae as L
};
//# sourceMappingURL=LinkPreviewCard-7d4ab2b6.mjs.map
